import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/store";
import ReusableModal from "../component/ReusableModal";
import { closeModal, getModalConfig } from "../../redux/modalSlice";

const ModalContainer = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state: RootState) => state.modal.isOpen);
  // configVersion changes every openModal — ensures fresh config is always read
  useSelector((state: RootState) => state.modal.configVersion);

  const config = isOpen ? getModalConfig() : null;

  if (!isOpen || !config) return null;

  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={() => dispatch(closeModal())}
      title={config.title}
      children={config.content}
      footerButtons={config.footerButtons}
      size={config.size || "lg"}
      centered={config.centered ?? true}
      closeButton={config.closeButton ?? true}
      className={config.className}
      backdrop={config.backdrop ?? true}
    />
  );
};

export default ModalContainer;
